<page-toolbar [pageActions]="pageActions" title="Profiles"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)" (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns"
                  [dataProviderParams]="dataProviderParams" [dataProvider]="profileService" [searchAll]="true" title="Profiles">
  </data-table>
</page-content>
